export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Elektroniczna rejestracja gości: Polizia di Stato (Włochy)",

  fields: {
    utente: "Utente",
    password: "Hasło",
    wskey: "WsKey",
    wskeyHint: "Klucz WsKey generuje się w portalu alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Rodzaj obiektu",
    idAppartamento: "ID apartamentu",
    idAppartamentoHint: "ID apartamentu zarejestrowanego w Alloggiati Web.",
    keepBlank: "(pozostaw puste, aby zachować obecną wartość)",
  },

  tipoOptions: {
    hotel: "Hotel / B&B / Dom wakacyjny",
    appartamento: "Zarządzany apartament",
  },

  actions: {
    saveAndVerify: "Zapisz i zweryfikuj",
    updateCredentials: "Zaktualizuj dane logowania",
    verifyConnection: "Zweryfikuj połączenie",
    saving: "Zapisywanie...",
    verifying: "Weryfikowanie...",
  },

  status: {
    connectionOk: "Dane logowania zapisane, a połączenie zweryfikowane pomyślnie.",
    connectionError: "Błąd połączenia. Prosimy sprawdzić wprowadzone dane logowania.",
    connectionPending: "Połączenie nie zostało jeszcze zweryfikowane. Kliknij \"Zweryfikuj połączenie\", aby potwierdzić.",
  },

  validation: {
    utenteRequired: "Pole Utente jest wymagane.",
    passwordRequired: "Hasło jest wymagane.",
    wskeyRequired: "Klucz WsKey jest wymagany.",
    idAppartamentoRequired: "ID apartamentu jest wymagane.",
  },

  toasts: {
    saveSuccess: "Dane logowania zapisane, a połączenie zweryfikowane pomyślnie.",
    saveWarning: "Dane logowania zapisane, ale nie udało się zweryfikować połączenia.",
    saveError: "Nie udało się zapisać danych logowania.",
    testSuccess: "Połączenie z Alloggiati Web zweryfikowane pomyślnie.",
    testError: "Nie udało się zweryfikować połączenia.",
    statusActive: "Alloggiati Web aktywowane.",
    statusInactive: "Alloggiati Web dezaktywowane.",
  },
};
